// extracted by css-extract-rspack-plugin
export default {"purchase":"YRMb6","with_subtitle":"Vo5uN","withSubtitle":"Vo5uN","subtitle":"lBiOv"};